import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import {
  NonBadgedPerson,
  NonBadgedPersonCreateUpdate,
  NonBadgedPersonImportSummary,
  PagedList,
  Pagination,
  ResultDto,
} from '#models';

const MAX_SEARCH_RESULTS = 10;

@Injectable({
  providedIn: 'root',
})
export class NonBadgedPersonService {
  private _httpClient = inject(HttpClient);
  private _baseUrl = `${environment.apiUrl}/non-badged-persons`;

  search(query: string): Observable<NonBadgedPerson[]> {
    return this._httpClient.get<NonBadgedPerson[]>(`${this._baseUrl}/search`, {
      params: { query, maxResults: MAX_SEARCH_RESULTS },
    });
  }

  getPagedList({ pageNumber, pageSize }: Pagination): Observable<PagedList<NonBadgedPerson>> {
    return this._httpClient.get<PagedList<NonBadgedPerson>>(`${this._baseUrl}/paged`, {
      params: { pageNumber, pageSize },
    });
  }

  create(dto: NonBadgedPersonCreateUpdate): Observable<NonBadgedPerson> {
    return this._httpClient.post<NonBadgedPerson>(this._baseUrl, dto);
  }

  update(id: number, dto: NonBadgedPersonCreateUpdate): Observable<NonBadgedPerson> {
    return this._httpClient.put<NonBadgedPerson>(`${this._baseUrl}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this._httpClient.delete<void>(`${this._baseUrl}/${id}`);
  }

  importFile(file: File): Observable<ResultDto<NonBadgedPersonImportSummary>> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this._httpClient.post<ResultDto<NonBadgedPersonImportSummary>>(`${this._baseUrl}/import`, formData);
  }
}
